<template>
    <div>
      <v-subheader>Manage</v-subheader>

      <!-- <v-list-item link :to="'/manage/buildings/'">
        <v-list-item-icon>
          <v-icon>mdi-office-building-cog-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Manage Buildings</v-list-item-title>
      </v-list-item> -->
      <v-list-item link :to="'/manage/analytics/'">
        <v-list-item-icon>
          <v-icon>mdi-google-analytics</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Analytics</v-list-item-title>
      </v-list-item>

      <v-list-item link :to="'/manage/groups/'">
        <v-list-item-icon>
          <v-icon>mdi-account-group-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Groups</v-list-item-title>
      </v-list-item>

      

      <v-list-item link :to="'/manage/maps/'">
        <v-list-item-icon>
          <v-icon>mdi-office-building-marker-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Manage Maps</v-list-item-title>
      </v-list-item>

      <v-divider></v-divider>

      <!-- <div v-for="(building, i) in buildings" :key="i">
          <v-list-item link :to="'/manage/spaces/objects/draw/'+building">
            <v-list-item-icon>
              <v-icon>mdi-map-marker-plus-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Edit Objects {{building}}</v-list-item-title>
          </v-list-item>
      </div> -->
    </div>
</template>

<script>

export default {
  name: 'MitMenuManager',
  components: {
  },
  props: {
    userModel: Object
  },
  data() {
      return {
        buildings:[],
      }
  },
  // created() {
  //       //get current settings
  //       MitSpacesService.getBuildingsMitIdUniqueList()
  //       .then((buildings) => {
  //           this.loadingBuildings = false;
  //           this.buildings = buildings;
  //           //select the first one by default
  //           if(this.buildings.length > 0){
  //               this.selectedBuilding = 0;
  //               this.selectBuilding();
  //           }
  //       })
  //       .catch((error)=>{
  //           this.loadingBuildings = false;
  //       });
  // }
}
</script>

<style lang="scss" scoped>
</style>
